// Exportación a Excel/CSV y a PDF.
//
// El Excel se arma con SheetJS. El PDF sale por la impresión del navegador
// ("Guardar como PDF"), que da mejor resultado que dibujar el documento a mano
// con una librería: respeta tipografías, se ve igual que en pantalla y no suma
// 300 kB al bundle.

// SheetJS pesa ~550 kB y sólo hace falta al exportar. Se carga en ese momento
// para no castigar la carga inicial en el teléfono.
let xlsxPromise = null;
function loadXlsx() {
  if (!xlsxPromise) xlsxPromise = import("xlsx");
  return xlsxPromise;
}

/** Descarga un .xlsx con una hoja por cada entrada de `sheets`. */
export async function exportToExcel(sheets, filename) {
  const XLSX = await loadXlsx();
  const book = XLSX.utils.book_new();

  for (const [name, rows] of Object.entries(sheets)) {
    const sheet = XLSX.utils.json_to_sheet(rows.length > 0 ? rows : [{}]);
    // Ancho de columna aproximado según el contenido más largo.
    if (rows.length > 0) {
      sheet["!cols"] = Object.keys(rows[0]).map((key) => ({
        wch: Math.min(
          40,
          Math.max(key.length + 2, ...rows.map((r) => String(r[key] ?? "").length + 2))
        ),
      }));
    }
    // Excel no admite nombres de hoja de más de 31 caracteres.
    XLSX.utils.book_append_sheet(book, sheet, name.slice(0, 31));
  }

  XLSX.writeFile(book, filename);
}

export async function exportToCsv(rows, filename) {
  const XLSX = await loadXlsx();
  const sheet = XLSX.utils.json_to_sheet(rows);
  const csv = XLSX.utils.sheet_to_csv(sheet);
  const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8" });
  triggerDownload(blob, filename);
}

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/**
 * Abre el diálogo de impresión con sólo el elemento indicado, para guardarlo
 * como PDF. Marca el nodo y deja que el CSS de impresión oculte el resto.
 */
export function printElement(element, title) {
  const previousTitle = document.title;
  // El nombre del archivo que sugiere el navegador sale del título del documento.
  document.title = title;
  element.classList.add("print-target");
  document.body.classList.add("printing");

  const cleanup = () => {
    element.classList.remove("print-target");
    document.body.classList.remove("printing");
    document.title = previousTitle;
    window.removeEventListener("afterprint", cleanup);
  };

  window.addEventListener("afterprint", cleanup);
  window.print();
  // Safari no siempre dispara afterprint.
  setTimeout(cleanup, 1000);
}
